import { createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-4" }

import WizardButton from '@/components/neue/wizard/WizardButton.vue'


export default {
  __name: 'WizardNav',
  props: {
  showBack: { type: Boolean, default: false },
  primaryLabel: { type: String, default: 'Continue' },
  primaryEnabled: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
  arrow: { type: Boolean, default: true }
},
  emits: ['back', 'primary'],
  setup(__props) {




return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.showBack)
      ? (_openBlock(), _createBlock(WizardButton, {
          key: 0,
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('back')))
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("← Back", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
    _createVNode(WizardButton, {
      variant: "primary",
      disabled: !__props.primaryEnabled,
      loading: __props.loading,
      onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('primary')))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.primaryLabel) + _toDisplayString(__props.arrow && !__props.loading ? ' →' : ''), 1)
      ]),
      _: 1
    }, 8, ["disabled", "loading"])
  ]))
}
}

}